import { render, staticRenderFns } from "./TreatmentSetInputForm.vue?vue&type=template&id=3149b509&scoped=true&"
import script from "./TreatmentSetInputForm.vue?vue&type=script&lang=js&"
export * from "./TreatmentSetInputForm.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSetInputForm.vue?vue&type=style&index=0&id=3149b509&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3149b509",
  null
  
)

export default component.exports